import { SEOItemList } from '../../types'
import { makeId } from '../utils'

export interface SEOItemListElementInput {
  docUrl: string
  title: string
  description?: string
}

export interface SEOItemListInput {
  name: string
  description: string
  canonicalUrl: string
  results: SEOItemListElementInput[]
}

export const getItemList = ({
  name,
  description,
  canonicalUrl,
  results = [],
}: SEOItemListInput): SEOItemList => ({
  '@type': 'ItemList',
  '@id': makeId(canonicalUrl, 'itemlist'),
  url: canonicalUrl,
  name,
  description,
  itemListElement: results.map(({ docUrl, title, description }, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    item: {
      '@id': docUrl,
      name: title,
      ...(description ? { description } : {}),
    },
  })),
})
